export enum Breakpoints {
  MOBILE = "500px",
  TABLET = "900px",
  DESKTOP = "1200px",
}
